const headerTitles = ["Home", "About", "Experience", "Blog", "Contact"];

export default headerTitles;
